var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('HeaderWithIconAtomStyled', [_c('IconStyled', [_vm._t("icon")], 2), _c('TitleStyled', [_vm._t("title")], 2)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }